export default "__VITE_ASSET__WBfWMrZo__"